export default __webpack_public_path__ + "static/media/267.0534d414.jpg";